// extracted by mini-css-extract-plugin
export default {"investmentCardWrapper":"styles_investmentCardWrapper__0NyNt","link":"styles_link__2+5t9","invCardIconWrapper":"styles_invCardIconWrapper__ChWpB"};